import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, Loader, Badge, Empty } from "@/components/shared";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, apiError } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { fmtDate, statusColor } from "@/lib/format";

export default function Support() {
  const { t } = useI18n();
  const [tickets, setTickets] = useState(null);
  const [form, setForm] = useState({ subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/support").then(({ data }) => setTickets(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!tickets) return <Loader />;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/support", form);
      toast.success("Ticket submitted"); setForm({ subject: "", message: "" }); load();
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader title={t("support")} subtitle="Open a ticket and track responses." />
      <div className="grid lg:grid-cols-2 gap-8 items-start">
        <form onSubmit={submit} className="ec-card p-6 space-y-4">
          <div><Label>{t("subject")}</Label><Input data-testid="support-subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} required className="mt-1" /></div>
          <div><Label>{t("message")}</Label><Textarea data-testid="support-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required className="mt-1" rows={5} /></div>
          <Button type="submit" disabled={busy} data-testid="support-submit" className="bg-orange-600 hover:bg-orange-500 btn-glow font-semibold px-8">{busy ? "..." : t("send")}</Button>
        </form>
        <div>
          <h3 className="font-head text-lg font-semibold text-white mb-4">{t("my_tickets")}</h3>
          {tickets.length === 0 ? <Empty label="No tickets yet." /> : (
            <div className="space-y-3">
              {tickets.map((tk) => (
                <div key={tk.id} className="ec-card p-4" data-testid={`ticket-${tk.id}`}>
                  <div className="flex items-center justify-between"><p className="font-semibold text-white text-sm">{tk.subject}</p><Badge className={statusColor(tk.status === "open" ? "open_ticket" : "resolved")}>{tk.status}</Badge></div>
                  <p className="text-sm text-gray-400 mt-1">{tk.message}</p>
                  {tk.reply && <p className="text-sm text-emerald-400 mt-2 border-t border-white/5 pt-2">Reply: {tk.reply}</p>}
                  <p className="text-xs text-gray-600 mt-1">{fmtDate(tk.created_at)}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
